import React, {useEffect} from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import {useTransition, animated} from 'react-spring'

import {imageType} from '../../../utils/commonPropTypes'
import {QueriedGatsbyImage} from '../../GatsbyImage'
import cross from '../images/cross.svg'
import arrow from '../images/arrow.svg'
import YoutubePlayer from './YoutubePlayer'


const RootContainer = styled(animated.div)`
	position: fixed;
	z-index: 150;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;	
	padding: 1rem;
	display: flex;
	align-items: center;
	justify-content: space-between;
`

const Background = styled.div`
	background: black;
	position: absolute;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	opacity: .7;
`

const Arrow = styled.img`
	color: white;
	font-size: 5rem;
	position: relative;
	transform: scale(1);
	transition: ${props => props.theme.transitions.smallElements} ease;
	cursor: pointer;
	&:hover {
		transform: scale(1.2);
	}
	
	${props => props.back && `
		transform: rotate(-180deg);
		
		&:hover {
			transform: rotate(-180deg) scale(1.2);
		}
	`}
`
Arrow.defaultProps = {
	alt: '',
	src: arrow,
}

const ContentContainer = styled.div`
	width: 60vw;
	position: relative;
	margin: 0 1rem;
`

const Image = styled(QueriedGatsbyImage)`
	max-width: 100%;
	max-height: 80vh;
	margin: 0;
	transform: scale(1);
`

const Exit = styled.img`
	position: absolute;
	top: 1rem;
	right: 1rem;
	transition: ${props => props.theme.transitions.smallElements} ease;
	cursor: pointer;
	
	&:hover {
		transform: scale(1.2)
	}
`
Exit.defaultProps = {
	alt: '',
	src: cross,
}

function Overlay({className, toShow, showArrows, visible, onHide, onNext, onPrevious}) {
	const keyPress = (e) => {
		switch (e.key) {
		case 'Escape':
			onHide()
			break
		case 'ArrowRight':
			onNext()
			break
		case 'ArrowLeft':
			onPrevious()
			break
		default:
			break
		}
	}

	useEffect(() => {
		if (visible) {
			document.addEventListener('keydown', keyPress)
		} else {
			document.removeEventListener('keydown', keyPress)
		}
		return () => document.removeEventListener('keydown', keyPress)
	}, [visible])

	const overlayTransitions = useTransition(visible, null, {
		from: {opacity: 0},
		enter: {opacity: 1},
		leave: {opacity: 0},
		config: {duration: 200},
	})

	return overlayTransitions.map(({key, item, props}) => item && <RootContainer
		key={key}
		style={props}
		className={className}>
		<Background/>
		<Exit onClick={onHide}/>
		{showArrows && <Arrow onClick={onPrevious} back/>}
		<ContentContainer>
			{!toShow.youtubeUrl && <Image image={toShow}/>}
			{toShow.youtubeUrl && <YoutubePlayer youtubeUrl={toShow.youtubeUrl}/>}
		</ContentContainer>
		{showArrows && <Arrow onClick={onNext}/>}
	</RootContainer>)
}

Overlay.propTypes = {
	className: PropTypes.string,
	toShow: PropTypes.oneOfType([
		imageType.isRequired,
		PropTypes.shape({
			youtubeUrl: PropTypes.string.isRequired,
		}).isRequired,
	]),
	showArrows: PropTypes.bool.isRequired,
	visible: PropTypes.bool.isRequired,
	onHide: PropTypes.func.isRequired,
	onNext: PropTypes.func.isRequired,
	onPrevious: PropTypes.func.isRequired,
}

Overlay.defaultProps = {
	className: '',
}

export default Overlay
